<template>
    <div class="location md-primary md-body-1" ref="location">
        <span class="location-text">
            {{'Latitude: ' + lat }} <br>
            {{' Longitude: ' + lng}}
        </span>
    </div>
</template>
<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
export default {
    props: {
        google: {
            type: Object,
            required: true
        },
        map: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            lat: 0,
            lng: 0
        }
    },
    mounted() {
        let self = this;
        const location = this.$refs.location;

        this.map.controls[this.google.maps.ControlPosition.BOTTOM_LEFT].push(location)

        this.google.maps.event.addListener(this.map, 'mousemove', function (event) {
            self.updateCoordinates(event.latLng);
        });
    },
    methods: {
        updateCoordinates(latLng){
            var lat = latLng.lat();
            var lng = latLng.lng();

            this.lat = lat.toFixed(4);
            this.lng = lng.toFixed(4);
        }
    }

}
</script>

<style scoped>
.location {
  background-color: white;
  width: 140px;
  padding: 0px;
  margin-bottom: 30px;
  margin-left: -65px;
}
.location-text {
    margin: 2px; 
}
</style>